import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Switch,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { I18n } from "aws-amplify/utils";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import Draggable from "react-draggable";

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      //handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function EmailAlarmPopup({ isOpen, onClose, alarmId, start }) {
  const [mailAlarm, setMailAlarm] = useState([]);
  const alarm = alarmId;
  useEffect(() => {
    const tlmGetReceivedEmail = async (alarmId) => {
      try {
        const restOperation = await get({
          apiName: "TelemonitoringAPI",
          path: "/receivedEmail/get",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {
              alarm_id: alarm,
              start_date:"",
              end_date:"",
              start: start
            },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        // console.log("response: ", response);
        setMailAlarm(response);
      } catch (error) {
        console.error("Error fetching alarms:", error);
        throw error;
      }
    };
    tlmGetReceivedEmail();
  }, []);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { width: "40%", maxWidth: "none" } }}
      PaperComponent={PaperComponent}
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title"> </DialogTitle>

      <DialogContent style={{ cursor: 'move' }}>
        <Box sx={{ mb: 1, fontSize: 18 }}>
          {mailAlarm.length > 0 ? (
            <List>
              {mailAlarm.map((item, index) => (
                <Box key={index}>
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {I18n.get("Receive date: ")}
                      </Typography>
                      <Typography variant="body2"> {item.receive_date}</Typography>
                    </Box>
                  </ListItem>
                  <Divider sx={{ marginY: 1 }} />
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {I18n.get("Email Address: ")}
                      </Typography>
                      <Typography variant="body2"> {item.email_from}</Typography>
                    </Box>
                  </ListItem>
                  <Divider sx={{ marginY: 1 }} />
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      <Typography variant="subtitle2" fontWeight="bold" fontSize={24}>
                        {I18n.get("Object: ")}
                      </Typography>
                      <Typography variant="body1"> {item.subject}</Typography>
                    </Box>
                  </ListItem>
                  <Divider sx={{ marginY: 1 }} />
                  <ListItem>
                    <Box sx={{display:"flex", gap: 2, alignItems: "center"}}>
                      {/* <Typography variant="subtitle2" fontWeight="bold">
                        {I18n.get("Receive date: ")}
                      </Typography> */}
                      <Typography variant="body2"> {parse(DOMPurify.sanitize(item.body))} </Typography>
                    </Box>
                  </ListItem>
                </Box>
              ))}
            </List>
          ) : (
            <Typography></Typography>
          )}
          {/* {JSON.stringify(mailAlarm, null, 2)} --> mostra il json */}
        </Box>
        {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose}>{I18n.get("Close")}</Button>
        </Box> */}
      </DialogContent>
      <DialogActions style={{ cursor: 'move' }}>
      <Button onClick={onClose}>{I18n.get("Close")}</Button>
      </DialogActions>
    </Dialog>
  );
}

EmailAlarmPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  alarmId: PropTypes.string.isRequired,
};

export default EmailAlarmPopup;
